module.exports = "<div class=\"col-sm-6 col-sm-offset-3 \">\n    <alert></alert>\n</div>\n\n<router-outlet *ngIf=\"navigationStatus\">\n    <div id=\"wrapper\" role=\"navigation\">\n        <app-navigation></app-navigation>\n    </div>\n</router-outlet>"


//////////////////
// WEBPACK FOOTER
// /var/www/html/foodbot_stage/web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main